import axios from "axios";

export const updateMondayFetItemPlatformStatus = async (
  mondayClientItemId: string | null,
  mondayPlatformStatus: string,
  additionalData?: Record<string, any>
): Promise<void> => {
  return await axios
    .post(
      `${process.env.NEXT_PUBLIC_API_URL}/integration/monday/platform-status`,
      {
        data: {
          mondayClientItemId,
          mondayPlatformStatus,
          additionalData,
        },
      }
    )
    .then((res) => res.data);
};
